import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo, Back, Sine } from 'gsap';
import { ScrollTrigger, DrawSVGPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {

        const delayOption = el.dataset.gridDelay;

        let nodes = el.querySelectorAll("[data-name='node']");
        let array = Array.from(nodes);
        let shuffledNodes = _.shuffle(array);

        let timeline = gsap.timeline({ paused: true, repeat: -1, yoyo: true, delay: delayOption });

        shuffledNodes.forEach((nodeGroups) => {

            var group = nodeGroups.querySelectorAll('g');

            group.forEach((element) => {

                var children = element.querySelectorAll('*');

                children.forEach((child) => {

                    timeline.from(child, {
                        duration: 3,
                        autoAlpha: 0,
                        drawSVG: 0,
                        ease: Expo.easeInOut
                    }, "<+1%");

                });

            });

        });



        timeline.play();


    });
}
